/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CorrespondingCredRequest,
  CorrespondingCredResponse,
  DossierDetailsResponseDto,
  DossierEdgedDetailsResponseDto,
} from '../models/index';
import {
    CorrespondingCredRequestFromJSON,
    CorrespondingCredRequestToJSON,
    CorrespondingCredResponseFromJSON,
    CorrespondingCredResponseToJSON,
    DossierDetailsResponseDtoFromJSON,
    DossierDetailsResponseDtoToJSON,
    DossierEdgedDetailsResponseDtoFromJSON,
    DossierEdgedDetailsResponseDtoToJSON,
} from '../models/index';

export interface GetCorrespondingDossierRequest {
    phoneNumber: string;
}

export interface GetCorrespondingPhoneNumberRequest {
    said: string;
}

export interface GetDossierDetailsRequest {
    said: string;
}

export interface GetDossierEdgedDetailsRequest {
    said: string;
}

export interface PostCorrespondingDossierRequest {
    correspondingCredRequest: CorrespondingCredRequest;
}

/**
 * 
 */
export class DossierControllerApi extends runtime.BaseAPI {

    /**
     * Get Dossier said by corresponding phone number
     */
    async getCorrespondingDossierRaw(requestParameters: GetCorrespondingDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorrespondingCredResponse>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling getCorrespondingDossier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/voice/dossier/corresponding/{phone_number}`.replace(`{${"phone_number"}}`, encodeURIComponent(String(requestParameters['phoneNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorrespondingCredResponseFromJSON(jsonValue));
    }

    /**
     * Get Dossier said by corresponding phone number
     */
    async getCorrespondingDossier(requestParameters: GetCorrespondingDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorrespondingCredResponse | null | undefined > {
        const response = await this.getCorrespondingDossierRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get phone number by corresponding Dossier said
     */
    async getCorrespondingPhoneNumberRaw(requestParameters: GetCorrespondingPhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorrespondingCredResponse>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getCorrespondingPhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/voice/dossier/corresponding-phone-number/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorrespondingCredResponseFromJSON(jsonValue));
    }

    /**
     * Get phone number by corresponding Dossier said
     */
    async getCorrespondingPhoneNumber(requestParameters: GetCorrespondingPhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorrespondingCredResponse | null | undefined > {
        const response = await this.getCorrespondingPhoneNumberRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get Dossier credentials details
     */
    async getDossierDetailsRaw(requestParameters: GetDossierDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DossierDetailsResponseDto>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getDossierDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/voice/dossier/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DossierDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Dossier credentials details
     */
    async getDossierDetails(requestParameters: GetDossierDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DossierDetailsResponseDto | null | undefined > {
        const response = await this.getDossierDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get Dossier credentials details with edged chain elements
     */
    async getDossierEdgedDetailsRaw(requestParameters: GetDossierEdgedDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DossierEdgedDetailsResponseDto>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getDossierEdgedDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/voice/dossier/edged/{said}`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DossierEdgedDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Dossier credentials details with edged chain elements
     */
    async getDossierEdgedDetails(requestParameters: GetDossierEdgedDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DossierEdgedDetailsResponseDto | null | undefined > {
        const response = await this.getDossierEdgedDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get Dossier said by corresponding phone number
     */
    async postCorrespondingDossierRaw(requestParameters: PostCorrespondingDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CorrespondingCredResponse>> {
        if (requestParameters['correspondingCredRequest'] == null) {
            throw new runtime.RequiredError(
                'correspondingCredRequest',
                'Required parameter "correspondingCredRequest" was null or undefined when calling postCorrespondingDossier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/voice/dossier/corresponding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CorrespondingCredRequestToJSON(requestParameters['correspondingCredRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CorrespondingCredResponseFromJSON(jsonValue));
    }

    /**
     * Get Dossier said by corresponding phone number
     */
    async postCorrespondingDossier(requestParameters: PostCorrespondingDossierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CorrespondingCredResponse | null | undefined > {
        const response = await this.postCorrespondingDossierRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
